import Vue from 'vue';

// Master view
import App from '@/App.vue';
import * as routerInitializer from '@/router';
import store from '@/store/store';
import VueI18n from 'vue-i18n';
import '@/filters/dateFilter';
import moment from 'moment';
import imgLazy from '@/directives/imgLazy';

// General CSS
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@fortawesome/fontawesome-pro/css/all.css';
import '@/scss/style.scss';
import BootstrapVue from 'bootstrap-vue';

registerServiceWorker();

Vue.directive('img-lazy', imgLazy);
Vue.use(BootstrapVue);
Vue.use(VueI18n);

/**
 * Dynamically creates routes by system
 */
routerInitializer.createDynamicRoutes((system: any, router: any) => {
	const i18n = new VueI18n({
		locale: system.culture,
	});
	moment.locale(system.culture.split('-')[0]);
	new Vue({
		router,
		store,
		render: (h) => h(App),
		i18n,
	}).$mount('#app');
}, (error: any) => {
	const offlineApp = () => import(`@/OfflineApp.vue`);
	new Vue({
		store,
		render: (h) => h(offlineApp),
	}).$mount('#app');
});

Vue.config.productionTip = false;

/**
 * Registeres service worker on load
 */
function registerServiceWorker() {
	if (process.env.mode !== 'production') {
		return;
	}
	if ('serviceWorker' in navigator) {
		window.addEventListener('load', () => {
			navigator.serviceWorker.register('/service-worker.js');
		});
	}
}
